import React, { useEffect } from "react";
import PaymentListing from "./PaymentListing";
import { columnTypes } from "src/components/UI/atoms/ATMTable/ATMTable";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "src/redux/store";
import {
  setPage,
  setRowsPerPage,
  setSearchValue,
  setIsTableLoading,
  setItems,
  setTotalItems,
} from "src/redux/slices/PaymentSlice";
import { useGetAllTransactionForExcelMutation, useGetAllTransactionQuery } from "src/services/TransactionService";
import { formatedDateTimeIntoIst } from "src/utils/formUtils/dateTimeFormate";
import ListDateTime from "src/components/UI/atoms/ListDateTime/ListDateTime";
import moment from "moment";
import { Tooltip } from "@mui/material";

type Props = {};

const PaymentListingWrapper = (props: Props) => {
  const dispatch = useDispatch();
  const {
    items,
    totalItems,
    page,
    rowsPerPage,
    searchValue,
    isTableLoading,
    dateFilter,
  } = useSelector((state: RootState) => state.payment);
  // const [excelPayemnt, setExcelPayemnt] = React.useState([]);

  const { data, isFetching, isLoading } = useGetAllTransactionQuery({
    limit: rowsPerPage,
    searchValue: searchValue,
    params: ["mobile", "remark"],
    page: page,
    filterBy: [],
    dateFilter: {
      startDate: dateFilter.start_date
        ? formatedDateTimeIntoIst(dateFilter.start_date, "YYYY-MM-DD")
        : "",
      endDate: dateFilter.end_date
        ? moment(dateFilter?.end_date).format("YYYY-MM-DD")
        : dateFilter.start_date ? moment().format("YYYY-MM-DD") : ''
      // : formatedDateTimeIntoIst(Date(), "YYYY-MM-DD"),
    },
    orderBy: "createdAt",
    orderByValue: -1,
    isPaginationRequired: true,
  });

  const [getPaymentExcel, getPaymnetExcelInfo] = useGetAllTransactionForExcelMutation()

  // const {
  //   data: excelData,
  //   isFetching: excelIsfetching,
  //   isLoading: excelIsLoading,
  // } = useGetAllTransactionQuery({
  //   limit: rowsPerPage,
  //   searchValue: searchValue,
  //   params: ["mobile"],
  //   page: page,
  //   filterBy: [],
  //   dateFilter: {
  //     startDate: dateFilter.start_date
  //       ? moment(dateFilter?.start_date).format("YYYY-MM-DD")
  //       : "",
  //     endDate: dateFilter.end_date
  //       ? moment(dateFilter?.end_date).format("YYYY-MM-DD")
  //       : dateFilter.start_date ? moment().format("YYYY-MM-DD") : ''
  //   },
  //   orderBy: "createdAt",
  //   orderByValue: -1,
  //   isPaginationRequired: false,
  // });

  // EXCEL 

  useEffect(() => {
    if (isLoading || isFetching) {
      dispatch(setIsTableLoading(true));
    } else {
      dispatch(setItems(data?.data || []));
      dispatch(setTotalItems(data?.totalItem || 0));
      dispatch(setIsTableLoading(false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading, isFetching, data]);

  // useEffect(() => {
  //   if (!excelIsfetching && !excelIsLoading) {
  //     setExcelPayemnt(excelData?.data || []);
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [excelIsfetching, excelIsLoading, excelData]);



  const columns: columnTypes[] = [
    {
      field: "createdAt",
      headerName: " Date",
      flex: "flex-[1_1_0%]",
      renderCell: (row: any) => <ListDateTime value={row.createdAt} />,
    },
    {
      field: "actualAmount",
      headerName: "Amount",
      flex: "flex-[1_1_0%]",
      renderCell: (row: any) => (
        <Tooltip title={row?.actualAmount || "-"}>
          <div className="capitalize"> {row?.actualAmount || "-"} </div>
        </Tooltip>
      ),
    },

    {
      field: "remark",
      headerName: "remark",
      flex: "flex-[1_1_0%]",
      renderCell: (row: any) => (
        <Tooltip title={row?.remark || "-"}>
          <div className="capitalize"> {row?.remark || "-"} </div>
        </Tooltip>)
    },
  ];

  return (
    <div>
      <PaymentListing
        columns={columns}
        getPaymentExcel={getPaymentExcel}
        isloadingExcel={getPaymnetExcelInfo.isLoading}
        rows={items}
        // excelData={excelPayemntData}
        paginationProps={{
          isTableLoading,
          totalItems,
          page,
          rowsPerPage,
          searchValue,
          setPage: (newPage) => dispatch(setPage(newPage)),
          setRowsPerPage: (newRowsPerPage) =>
            dispatch(setRowsPerPage(newRowsPerPage)),
          setSearchValue: (newValue) => dispatch(setSearchValue(newValue)),
        }}
      />
    </div>
  );
};

export default PaymentListingWrapper;
